var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "data-big-screen" },
    [
      _c(
        "a-button",
        {
          staticClass: "skip-btn",
          attrs: { type: "primary" },
          on: { click: _vm.getSkipUrl },
        },
        [_vm._v("立即进入")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }